export class WebPageAreaModel {
    id?: string | undefined;
    name?: string | undefined;
    nodeNameList?: string | undefined;
    webPageUrl?: string | undefined;
    generalSelector?: string | undefined;
    collectAllSelectors?: string | undefined;
    idList?: string | undefined;
    cssClassList?: string | undefined;
    removeFilterList?: string | undefined;
    extensionName?: string | undefined;
    patreonName?: string | undefined;
    status?: EntityStatus;
}

export enum EntityStatus {
    Accepted = 'accepted',
    Rejected = 'rejected',
    Pending = 'pending',
}
